/**
 * 初始化一些数据，保证页面刷新时store中的数据都是有赋值的
 */

import { useAppStore, useDataStore, useUserStore,useIndexStore } from '@/store'
import defaultConfig from '@/configs/default.config'
import storage from '@/utils/storage'
import { level } from 'province-city-china/data'
import { clone, getAreaOptions } from '@/utils'

export default {
  init() {
    console.log('载入默认配置')
    const appStore = useAppStore()
    const userStore = useUserStore()
    const dataStore = useDataStore()
    const indexStore = useIndexStore()

    appStore.$patch({
      host: defaultConfig.host,
      company: defaultConfig.company,
      version: defaultConfig.version,
      projectTitle: defaultConfig.project_title,
      contactWay: defaultConfig.contact_way,
      checkAuth: defaultConfig.check_auth
    })

    const adSlotOptions = [
      {label: '开屏页', value: 0},
      {label: '主页', value: 1},
      {label: '我的', value: 2},
      {label: '订单', value: 3},
      {label: '文章', value: 4}
    ]
    const linkTypeOptions = [
      {label: '小程序', value: 0},
      {label: '网页', value: 1},
      {label: 'App', value: 2}
    ]
    const areaOptions = getAreaOptions(clone(level))
    dataStore.$patch({
      adSlotOptions,
      areaOptions,
      linkTypeOptions
    })

    // 0:等待开始 1：进行中 2：活动结束
    const activityStateOptions = [
      {label: '等待开始', value: 0},
      {label: '进行中', value: 1},
      {label: '活动结束', value: 2}
    ]
    const auditStatusOptions = [
      {label: '待审核', value: 0},
      {label: '审核通过', value: 1},
      {label: '审核驳回', value: 2}
    ]
    indexStore.$patch({
      activityStateOptions,
      auditStatusOptions
    })


    userStore.setToken(storage.get<string>('BEARER_TOKEN') as string)
  }
}